import script from "./PostFoot.vue?vue&type=script&setup=true&lang=js"
export * from "./PostFoot.vue?vue&type=script&setup=true&lang=js"

import "./PostFoot.vue?vue&type=style&index=0&id=7b1d9e06&lang=css"

const __exports__ = script;

export default __exports__